import React, { useEffect, useMemo, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./EditFAQ.css";
import { useDispatch, useSelector } from "react-redux";
import { updateFAQ, getFAQById } from "../../Redux/Actions/faqsAction";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const EditFAQ = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { enumsData = {} } = useSelector((state) => state.enumsData || {});
  const { loading = false, singleFaq = null } = useSelector(
    (state) => state.faq || {}
  );
  console.log("djbdhhf",singleFaq)

  const [formData, setFormData] = useState({
    page: "",
    question: "",
    answer: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(getEnums());
    if (id) {
      dispatch(getFAQById(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (singleFaq) {
      setFormData({
        page: singleFaq.page || "",
        question: singleFaq.question || "",
        answer: singleFaq.answer || "",
      });
    }
  }, [singleFaq]);

  const pageOptions = useMemo(() => {
    return enumsData?.data?.pageName
      ? Object.entries(enumsData.data.pageName)
      : [];
  }, [enumsData]);

  const isGeneralQueries = useMemo(() => {
    const selectedValue = String(formData.page || "").toLowerCase();
    return (
      selectedValue === "general_queries" ||
      selectedValue === "general queries" ||
      selectedValue === "generalquery" ||
      selectedValue === "generalqueries"
    );
  }, [formData.page]);

  const clearError = (field) => {
    setErrors((prev) => {
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "page") {
        const nextValue = String(value || "").toLowerCase();
        const isGeneral =
          nextValue === "general_queries" ||
          nextValue === "general queries" ||
          nextValue === "generalquery" ||
          nextValue === "generalqueries";

        if (isGeneral) {
          updated.answer = "";
        }
      }

      return updated;
    });

    clearError(name);

    if (name === "page") {
      clearError("answer");
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.page) {
      newErrors.page = "Please select a page";
    }

    if (!formData.question.trim()) {
      newErrors.question = "Question is required";
    }

    if (!isGeneralQueries && !formData.answer.trim()) {
      newErrors.answer = "Answer is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFAQSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (!validate()) return;

    try {
      const payload = {
        _id: id,
        page: formData.page,
        question: formData.question.trim(),
      };

      if (!isGeneralQueries) {
        payload.answer = formData.answer.trim();
      }

      const response = await dispatch(updateFAQ(payload));

      if (response?.statusCode === 200 || response?.success) {
        toast.success("FAQ updated successfully");
        navigate("/faq");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update FAQ";

      toast.error(errorMessage);
    }
  };

  const showError = (field) => submitted && errors[field];

  return (
    <MainLayout>
      <div className="ef-wrapper">
        <div className="ef-header">
          <div className="ef-header-left">
            <div className="ef-header-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </div>

            <div>
              <h1 className="ef-title">Edit FAQ</h1>
              <p className="ef-subtitle">Update an existing frequently asked question</p>
            </div>
          </div>

          <button
            type="button"
            className="ef-view-btn"
            onClick={() => navigate("/faq")}
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
            View FAQ List
          </button>
        </div>

        <form className="ef-card" onSubmit={handleFAQSubmit}>
          <div className="ef-section-head">
            <span className="ef-section-badge">FAQ</span>
            <h2 className="ef-section-title">FAQ Details</h2>
          </div>

          <div className="ef-field">
            <label className="ef-label" htmlFor="ef-page">
              Page <span className="ef-req">*</span>
            </label>

            <div
              className={`ef-select-wrap ${
                showError("page") ? "ef-input--error" : ""
              }`}
            >
              <select
                id="ef-page"
                name="page"
                value={formData.page}
                onChange={handleChange}
                className="ef-select"
                disabled={loading}
              >
                <option value="">Select a page…</option>

                {pageOptions.length > 0 ? (
                  pageOptions.map(([key, value]) => (
                    <option key={key} value={value}>
                      {key}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    Loading options…
                  </option>
                )}
              </select>

              <svg
                className="ef-select-arrow"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>

            {showError("page") && (
              <span className="ef-error-msg">{errors.page}</span>
            )}
          </div>

          <div className="ef-divider" />

          <div className="ef-field">
            <label className="ef-label" htmlFor="ef-question">
              Question <span className="ef-req">*</span>
            </label>

            <div className="ef-textarea-wrap">
              <svg
                className="ef-textarea-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>

              <textarea
                id="ef-question"
                name="question"
                className={`ef-textarea ${
                  showError("question") ? "ef-input--error" : ""
                }`}
                value={formData.question}
                onChange={handleChange}
                rows={4}
                placeholder="Type your question here…"
                disabled={loading}
              />
            </div>

            {showError("question") && (
              <span className="ef-error-msg">{errors.question}</span>
            )}
          </div>

          {!isGeneralQueries && (
            <>
              <div className="ef-divider" />

              <div className="ef-field">
                <label className="ef-label" htmlFor="ef-answer">
                  Answer <span className="ef-req">*</span>
                </label>

                <div className="ef-textarea-wrap">
                  <svg
                    className="ef-textarea-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>

                  <textarea
                    id="ef-answer"
                    name="answer"
                    className={`ef-textarea ${
                      showError("answer") ? "ef-input--error" : ""
                    }`}
                    value={formData.answer}
                    onChange={handleChange}
                    rows={5}
                    placeholder="Type your answer here…"
                    disabled={loading}
                  />
                </div>

                {showError("answer") && (
                  <span className="ef-error-msg">{errors.answer}</span>
                )}
              </div>
            </>
          )}

          {isGeneralQueries && (
            <>
              <div className="ef-divider" />
              <div className="ef-info-box">
                <span className="ef-info-badge">Optional rule</span>
                <p className="ef-info-text">
                  For General Queries, the answer field is not required.
                </p>
              </div>
            </>
          )}

          <div className="ef-footer">
            <button
              type="button"
              className="ef-btn ef-btn--cancel"
              onClick={() => navigate("/faq")}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="ef-btn ef-btn--submit"
              disabled={loading}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {loading ? "Updating..." : "Update FAQ"}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditFAQ;